module.exports = __webpack_public_path__ + "img/modal.58e97327.png";